import React from 'react'
import styled from 'styled-components';

const StyledTitle = styled.h6`
display : flex;
justify-content : ${props => props.center ? 'center' : 'flex-start'};
font-size : 0.9em;
color : #999999 ;
font-weight : 600;
width: ${props => props.width || '100%'};
margin : 0px;
padding : 8px 0px 8px 0px;
height: auto;
`
export const Title = (props) => {
    return (
        <StyledTitle
            {...props}
        >
            {props.children}
        </StyledTitle>
    )
}